import React, { useEffect, useState, useMemo } from 'react';
import { useMutation, useQuery } from 'react-query';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router';
import Spinner from 'components/Spinner/Spinner';
import Contents from 'components/Layout/Contents';
import { ModalDialog } from 'components/ModalDialog/ModalDialog';
import useLayout from 'components/Layout/useLayout';
import Table from 'components/Table/Table';
import CompetencyService from 'api/CompetencyService';
import CompetencyRowItem from './CompetencyTable/CompetencyRowItem';
import { TableContext } from '../../components/Table/TableContext';

export default function Competencies() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [specParam, setSpecParam] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [isDeleting, setDeleting] = useState(false);
  const { scrollToTop } = useLayout();
  const { data, isLoading, isRefetching, isError, error, refetch } = useQuery(
    [],
    () => CompetencyService.getAll(),
    {
      staleTime: 0,
      enabled: false,
    }
  );
  const mutationDelete = useMutation((id) => CompetencyService.deleteById(id), {
    onMutate: () => {
      setDeleting(true);
    },
    onSuccess: () => {
      setErrMsg();
      refetch();
      setDeleting(false);
    },
    onError: (err) => {
      setErrMsg(err.response.data.title);
    },
  });

  const handleClickEdit = (id) => {
    navigate(`/competencies/${id}/edit`);
  };
  const handleClickDelete = (id) => {
    setOpen(true);
    setSpecParam(id);
  };

  const onDeleteConfirm = () => {
    mutationDelete.mutate(specParam);
    // console.log(itemParam);
    setOpen(false);
  };

  const actions = useMemo(
    () => ({
      onClickEdit: handleClickEdit,
      onClickDelete: handleClickDelete,
    }),
    []
  );

  useEffect(() => {
    refetch().then();
    scrollToTop();
  }, []);

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return (
      <>
        <h2 data-testid="Header-error">There is an error</h2>
        <p className="alert alert-danger">{error.message}</p>
      </>
    );
  }

  return (
    <Contents>
      <TableContext.Provider value={actions}>
        <Table
          title="Specialties"
          name="competency"
          columns={['Specialty ID', 'Specialty Name']}
          dataSource={data?.data}
          isLoading={isLoading || isDeleting || isRefetching}
          isError={isError}
          creationLink="/competencies/add"
          rowComponent={CompetencyRowItem}
          renderError={() => (
            <p className="alert alert-danger">
              <FontAwesomeIcon icon={faExclamationCircle} /> {errMsg}
            </p>
          )}
          actionWidth="110px"
          striped
          bordered
          hover
          enablePagination
        />
      </TableContext.Provider>
      <ModalDialog
        open={open}
        setOpen={setOpen}
        header="Delete Specialty"
        message="You are about to delete a specialty. Are you sure about it?"
        onConfirm={onDeleteConfirm}
        dataTestid="Modal-deleteCompetency"
      />
    </Contents>
  );
}
